import { render, staticRenderFns } from "./updateRoles.vue?vue&type=template&id=13ef665e&scoped=true&"
import script from "./updateRoles.vue?vue&type=script&lang=js&"
export * from "./updateRoles.vue?vue&type=script&lang=js&"
import style0 from "./updateRoles.vue?vue&type=style&index=0&id=13ef665e&prod&scoped=true&lang=css&"
import style1 from "./updateRoles.vue?vue&type=style&index=1&id=13ef665e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ef665e",
  null
  
)

export default component.exports